import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M705.45 546.133H311.04a37.945 37.945 0 1 1 0-75.833h394.41a37.945 37.945 0 1 1 0 75.833M508.218 0a508.188 508.188 0 1 0 0 1016.434A508.188 508.188 0 0 0 508.217 0" fill="#F54A44" /></svg>

const DeleteCircle = React.forwardRef((props, ref) => {
  return (
    <IconBase name="delete-circle" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

DeleteCircle.displayName = 'IconDeleteCircle'

export default DeleteCircle
